import { motion } from "framer-motion";
import { IMAGES } from "../data/content";

export const About = () => {
  return (
    <section
      id="estate"
      data-testid="about-section"
      className="bg-[#F6F5F0] py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-20 items-center">
        {/* Tetris image grid */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="relative mb-10 md:mb-0"
        >
          <img
            src={IMAGES.estateExterior}
            alt="Heritage stone bungalow at Nine Furlongs"
            className="w-full sm:w-[78%] h-[320px] sm:h-[460px] object-cover"
          />
          <img
            src={IMAGES.estateNature}
            alt="Forest surrounding the estate"
            className="hidden sm:block absolute bottom-[-40px] right-0 w-[52%] h-[260px] object-cover border-[6px] border-[#F6F5F0] shadow-xl"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1 }}
        >
          <p className="uppercase text-xs tracking-[0.25em] text-[#C4A575] font-semibold">
            The Estate · Since the 1950s
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-primary mt-4 leading-tight">
            A heritage written into the forest itself
          </h2>
          <p className="text-text-muted mt-6 leading-relaxed" style={{ color: "#5A655E" }}>
            The bungalows are as much a part of the land as the evergreen
            forests that surround them. After the British owners left around
            India's independence, the Belgian musicologist Marie Therese Domine
            made the estate her resting point in the early 1950s — writing of her
            epic journey across the Himalayas on foot, in bullock carts and local
            trains.
          </p>
          <p className="text-text-muted mt-4 leading-relaxed" style={{ color: "#5A655E" }}>
            Today, Nine Furlongs carries that same spirit — a place to live by
            your own rhythm, surrounded by a land that has witnessed centuries of
            crowns, capitals and quiet mountain wisdom.
          </p>

          <div className="mt-8 border-l-2 border-[#C4A575] pl-6">
            <p className="font-serif italic text-xl md:text-2xl text-primary leading-snug">
              "Every place has a sound. Here, it is the rustle of the forest in
              the wafting breeze."
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
